<template>
  <div class="sn-f-b-s case-detail">
    <sn-navigator id="BLCX" :initial="initial"></sn-navigator>
    <div class="sn-f-1 sn-f-s-1 sn-f-col-b-s case-detail-region">
      <sn-breadcrumb :breadcrumb="[{
        title: $sn.utils.getFunctionTitle('0', initial),
        replace: true,
        router: `/query/case?type=${caseType}`
      }, {
        title: `${$sn.utils.getFunctionTitle('0', initial)}详情`
      }]"></sn-breadcrumb>
      <div class="sn-f-1 sn-f-s-1 detail-blank">
        <template v-if="!$sn.validate.empty(caseDetailInfo)">
          <div class="sn-f-c-c detail-title">{{$sn.utils.getHospitalTitle()}}</div>
          <div class="sn-f-c-c detail-sub-title">{{$sn.utils.getFunctionTitle('0', initial)}}</div>
          <div class="sn-f-b-c detail-head">
            <div v-if="caseDetailInfo.patient.patientName">姓名：{{caseDetailInfo.patient.patientName}}</div>
            <div v-if="formatAgeSex('sex', caseDetailInfo.patient)">性别：{{formatAgeSex('sex', caseDetailInfo.patient)}}</div>
            <div v-if="formatAgeSex('age', caseDetailInfo.patient)">年龄：{{formatAgeSex('age', caseDetailInfo.patient)}}</div>
          </div>
          <div class="sn-f-b-c detail-head detail-head-one">
            <div v-if="caseDetailInfo.deptName">就诊科室：{{caseDetailInfo.deptName}}</div>
            <div v-if="caseDetailInfo.schDate">就诊时间：{{caseDetailInfo.schDate}}</div>
          </div>
          <div class="detail-content">
            <div class="sn-f-s-s single">
              <div class="single-left">主诉：</div>
              <div class="single-right">{{reveal('chiefComplaint', caseDetailInfo)}}</div>
            </div>
            <div class="sn-f-s-s single">
              <div class="single-left">现病史：</div>
              <div class="single-right">{{reveal('medicalHistory', caseDetailInfo)}}</div>
            </div>
            <div class="sn-f-s-s single">
              <div class="single-left">体格检查：</div>
              <div class="single-right">{{reveal('physicalExamination', caseDetailInfo)}}</div>
            </div>
            <div class="sn-f-s-s single">
              <div class="single-left">辅助检查：</div>
              <div class="single-right">{{reveal('SupplementaryExamination', caseDetailInfo)}}</div>
            </div>
            <div class="sn-f-s-s single">
              <div class="single-left">其他：</div>
              <div class="single-right">{{reveal('OtherProcessing', caseDetailInfo)}}</div>
            </div>
            <div class="sn-f-s-s single">
              <div class="single-left">诊断：</div>
              <div class="single-right">{{reveal('DiagnosticContent', caseDetailInfo)}}</div>
            </div>
            <div class="sn-f-s-s single">
              <div class="single-left">处方：</div>
              <div class="single-right">{{reveal('PrescriptionInformation', caseDetailInfo)}}</div>
            </div>
          </div>
        </template>
        <template v-else>
          <sn-no-data></sn-no-data>
        </template>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import * as Constants from '@/common/utils/constants';

export default {
  data() {
    return {
      caseType: '',
      caseDetailInfo: {}
    };
  },
  computed: {
    // 当前功能 ID
    initial() {
      return [Constants.FUNCTION_ID_MZBLCX, Constants.FUNCTION_ID_ZYBLCX][this.caseType - 1];
    },
    reveal() {
      return (key, item) => {
        let value = '无';
        const defaultValueMap = {
          'chiefComplaint': '主诉：',
          'medicalHistory': '病史：',
          'physicalExamination': '体格检查：',
          'SupplementaryExamination': '辅助检查：',
          'OtherProcessing': '其他：',
          'DiagnosticContent': '诊断：',
          'PrescriptionInformation': '处方：'
        };
        if (item[key] && item[key] !== defaultValueMap[key]) {
          value = item[key].replace(defaultValueMap[key], '').trim();
        }
        return value;
      };
    }
  },
  watch: {},
  created: function() {
    this.caseType = this.$route.query.type || '1';
    document.title = `${this.$sn.utils.getFunctionTitle('0', this.initial)}详情`;
    this.$route.meta.title = `${this.$sn.utils.getFunctionTitle('0', this.initial)}详情`;
    this.caseDetailInfo = this.$sn.utils.getHospitalSessionStorage('Query_CaseReportInfo');
  },
  methods: {
    formatAgeSex(type, item) {
      if (type === 'sex') {
        let patientSex = '';
        if (item.isChildren === '0' && item.idCardType === '0') {
          patientSex = this.$sn.format.sexByIdCardSerial(item.patientIdCardNo);
        }
        else {
          patientSex = item.patientSex ? item.patientSex : '';
        }
        return patientSex ? this.$sn.format.sex(patientSex) : '';
      }
      else if (type === 'age') {
        let birthday = '';
        if (item.isChildren === '0' && item.idCardType === '0') {
          birthday = this.$sn.format.birthdayByIdCardSerial(item.patientIdCardNo);
        }
        else {
          const date = item.patientBirthday ? item.patientBirthday : '';
          const regex = /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
          if (date) {
            birthday = regex.test(date) ? date : `${date.substring(0, 4)}-${date.substring(4, 6)}-${date.substring(6, 8)}`;
          }
        }
        return this.$sn.format.ageByBirthday(birthday) === 0 ? '不足一岁' : `${this.$sn.format.ageByBirthday(birthday)}岁`;
      }
    }
  },
  beforeDestroy() {}
};
</script>
<style lang="scss" scoped>
.case-detail {
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  background: $white;
  left: 0;
  top: 0;

  &-region {
    overflow: hidden;
    height: 100%;

    .detail-blank {
      overflow: hidden;
      width: 100%;
      height: 100%;
      padding: 20px 10% 0;
      display: flex;
      flex-direction: column;

      .detail-title {
        font-size: 24px;
        font-weight: bold;
      }

      .detail-sub-title {
        font-size: 22px;
        font-weight: bold;
        margin-top: 20px;
      }

      .detail-head {
        font-size: 20px;
        padding: 20px 30px 20px 0;

        &-one {
          padding: 0 30px 20px 0;
          border-bottom: 1px solid $text1;
        }
      }

      .detail-content {
        font-size: 20px;
        overflow-y: auto;
        padding-bottom: 20px;

        .single {
          margin-top: 20px;

          &-left {
            width: 15%;
          }

          &-right {
            width: 85%;
          }
        }
      }
    }
  }
}
</style>
